import type { SelectedFile } from '../../../components/forms/FileUpload';
import type { RepeatableInstanceSaveHandle } from '../../../components/repeatableSections/repeatableInstanceSaveHandle';
import type { SavedAttachment } from '../../../services/attachmentService';
import type { Request } from '../../../types';
import type { FacilityPowerInstance } from '../../../types/facilityPowerInstance';

export interface FacilityPowerInitialProps {
  formData: Record<string, unknown> & {
    stage?: string;
    sysRequestStage?: string;
  };
  updateFormData: (
    field: string,
    value: string | FacilityPowerInstance[] | undefined,
  ) => void;
  requestId?: string;
  disabled?: boolean;
  attachmentsBySection?: Record<string, SavedAttachment[]>;
  onAttachFiles?: (sectionId: string) => void;
  onDeleteAttachment?: (attachmentId: number) => void;
  isEditing?: boolean;
  selectedFiles?: Record<string, SelectedFile[]>;
  onFilesSelected?: (sectionId: string, files: SelectedFile[]) => void;
  offlineMode?: boolean;
  showFullDetails?: boolean;
  enabledStepIds?: readonly string[];
  registerInstanceSaveHandle?: (
    handle: RepeatableInstanceSaveHandle | null,
  ) => void;
  onInstanceEditorActiveChange?: (
    active: boolean,
    footerSaveLabel?: string,
  ) => void;
}

export interface FacilityPowerPersistedProps {
  request: Request;
  isEditing: boolean;
  editedData: Record<string, unknown>;
  updateEditedData: (field: string, value: string) => void;
  showFullDetails?: boolean;
  showViewToggle?: boolean;
  isAdvancedView?: boolean;
  onToggleView?: () => void;
  attachmentsBySection?: Record<string, SavedAttachment[]>;
  onAttachFiles?: (sectionId: string) => void;
  onDeleteAttachment?: (attachmentId: number) => void;
  selectedFiles?: Record<string, SelectedFile[]>;
  onFilesSelected?: (sectionId: string, files: SelectedFile[]) => void;
  offlineMode?: boolean;
  onCaptionChange?: (attachmentId: number, caption: string) => void;
  pendingCaptionEdits?: Record<number, string>;
  enabledStepIds?: readonly string[];
  registerInstanceSaveHandle?: (
    handle: RepeatableInstanceSaveHandle | null,
  ) => void;
  onInstanceEditorActiveChange?: (
    active: boolean,
    footerSaveLabel?: string,
  ) => void;
  applyEditedDataPatch?: (patch: Record<string, unknown>) => void;
}

export type FacilityPowerProps =
  | FacilityPowerInitialProps
  | FacilityPowerPersistedProps;

export function isFacilityPowerPersistedProps(
  p: FacilityPowerProps,
): p is FacilityPowerPersistedProps {
  return 'request' in p && (p as FacilityPowerPersistedProps).request != null;
}
